import { getFormApiHost, getSiteGovernUrl } from './customer';
const formHost = getFormApiHost();
const sgUrl = getSiteGovernUrl();

const apiConfig = {
    endpoint: `${formHost}/subm/submit`,
    sgUrl: sgUrl,
    GetApiUrl: `${formHost}/form`,
    GetSubmissionViewUrl: `${formHost}/subm/view`,
    GetSubmissionUrl: `${formHost}/_debug/subm`,
    PostApiUrl: `${formHost}/ws`
};
export { apiConfig };